import { withStyles } from '@material-ui/core/styles'
import TableCell from '@material-ui/core/TableCell'

const CustomTableCell = withStyles(theme => ({
  root: {
    height: 40,
    fontSize: 13,
    paddingTop: 0,
    paddingBottom: 0,
    border: '1px solid #C8C8C7'
  }
}))(TableCell)

export const HeadCustomTableCell = withStyles(theme => ({
  root: {
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 1.0)'
  }
}))(CustomTableCell)

export const BodyCustomTableCell = withStyles(theme => ({
  root: {
    textAlign: 'center'
  }
}))(CustomTableCell)

export default CustomTableCell
